import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect, useRef, useState } from "react";

import houseHoldDatabaseKeys from "HouseholdDatabase/API/keys";
import API from "Signups/FamilyRegistration/API";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";

export default function useUpdateSetting(thing) {
  const { dispatch } = useFamilyRegistrationContext();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState();
  const isMounted = useRef(true);
  const queryClient = useQueryClient();

  // tracking whether or not component is currently mounted to avoid updating on an unmounted component
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const updateSetting = useCallback(
    async (postData) => {
      if (saving) return;
      setSaving(true);
      setError(undefined);

      try {
        const res = await API.updateSetting(postData).post();

        const { familyRegistrationSettings } = res;

        if (isMounted.current) {
          setSaving(false);
          dispatch({
            type: "setSetting",
            payload: familyRegistrationSettings,
          });
          queryClient.invalidateQueries(houseHoldDatabaseKeys.all());
        }
        return familyRegistrationSettings;
      } catch (err) {
        setError(err);
        setSaving(false);
        throw Error(err?.message || err || "Error updating setting");
      }
    },
    [saving, dispatch, queryClient]
  );

  const clearError = useCallback(() => {
    setError(undefined);
  }, []);

  return { updateSetting, saving, error, clearError, setError };
}
